import React, { FC } from 'react';

import SeoLocationHero from '@rover/react-lib/src/pages/landing/SeoLocation/components/SeoLocationHero';
import type { SeoLocationDetails } from '@rover/rsdk/src/apiClient/latest/model/seoLocationDetails';

import DogTrainingLandingSearchForm from '../../../../components/DogTrainingLandingSearchForm';
import { dogTrainingHeroImage } from '../../../images';

type Props = {
  details: SeoLocationDetails;
};

const TrainingSeoLocationHero: FC<Props> = ({ details }) => (
  <SeoLocationHero
    heading={details.h1}
    subheading={details.h2}
    desktopImage={dogTrainingHeroImage}
    petType={details.petType}
    internalServiceTypeSlug={details.internalServiceType.slug}
    serviceTypeName={details.serviceTypeName}
    locationName={details.name}
    searchForm={<DogTrainingLandingSearchForm />}
  />
);

export default TrainingSeoLocationHero;
